<template>
  <div :class="[level ? `subtitle-${level-1}` : 'headline']" class="dashboard-title">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    level: {
      type: [Number, String],
      default: null,
    },
    noBorder: Boolean,
  },
};
</script>
<style lang="scss" scoped>
  .dashboard-title {
    font-weight: 500;
    color: #212121;
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .dashboard-title {
      font-size: 1.25rem;
      line-height: 1;
    }
  }

</style>
